__turbopack_context__.v({
  "button": "button-module__H8l7zG__button",
});
